module.exports = __webpack_public_path__ + "img/login-background.170db248.jpg";